class CScrollBarWidth {
    private static iScrollBarWidth = -1

    public static getScrollBarWidth(): number {
        if (CScrollBarWidth.iScrollBarWidth < 0) {
            this.iScrollBarWidth = this.MeasureScrollBar()
        }

        return this.iScrollBarWidth
    }

    private static MeasureScrollBar(): number {
        // Create the measurement node
        const scrollDiv = document.createElement('div')
        scrollDiv.className = 'scrollbar-measure'
        document.body.appendChild(scrollDiv)

        // Get the scrollbar width
        const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth

        // Delete the DIV
        document.body.removeChild(scrollDiv)
        return Math.ceil(scrollbarWidth)
    }
}

export default CScrollBarWidth
